import { useTranslation } from '@jq4race/i18n';
import { Button } from '@jq4race/ui';
import { Link } from '@tanstack/react-router';

/**
 * Global fallback for unmatched routes. Registered as the router's
 * `defaultNotFoundComponent` so no navigation can dead-end without UI —
 * e.g. a drill-down link whose target route has not shipped yet.
 */
export function NotFoundPage() {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-jq-graphite">
        {t('notFound.code')}
      </p>
      <h1 className="text-[22px] font-semibold text-jq-charcoal">{t('notFound.title')}</h1>
      <p className="max-w-sm text-[13px] text-jq-graphite">{t('notFound.description')}</p>
      <Button asChild>
        <Link to="/dashboard">{t('notFound.back')}</Link>
      </Button>
    </div>
  );
}
